module.exports = __webpack_public_path__ + "img/dd865b3.png";